import { FC, useCallback, PropsWithChildren } from "react";
import { OpenUrlCallback } from "../../hooks/useOpenUrlCallback";
import { useChatDispatch } from "../../utils/useChatDispatch";
import { ChatState, VisualState } from "../../store/ChatState";
import { useSelector } from "react-redux";

export interface OptionalLinkProps {
    readonly url?: string;
    readonly className?: string;
    onOpen: OpenUrlCallback;
    onClick: () => void;
}

export const OptionalLink: FC<PropsWithChildren<OptionalLinkProps>> = (props) => {
    const chatDispatch = useChatDispatch();
    const visuals = useSelector<ChatState, VisualState>((state) => state.visuals);

    const { url, className, onOpen } = props;

    const handleOpenUrl = useCallback(() => {
        if (onOpen) {
            onOpen(url, chatDispatch, visuals);
        }
    }, [url, onOpen]);

    if (url) {
        return (
            <div onClick={handleOpenUrl} className={className}>
                {props.children}
            </div>
        );
    } else {
        return (
            <div onClick={props.onClick} className={className}>
                {props.children}
            </div>
        );
    }
};
